import React from 'react';

import styled from 'styled-components';

import { Button } from 'components/atoms/Button';
import color from 'ui/theme/color';

type Props = {
  // 削除表示などエラー体裁にしたくない場合に見出しを差し替える（省略時は従来のエラー見出し）
  title?: string;
  cause?: string;
  solution?: string;
  onBackToTop: () => void;
};

const ErrorPage: React.FC<Props> = (props) => (
  <Container>
    <Title>{props.title ?? 'エラーが発生しました'}</Title>
    {(props.cause || props.solution) && (
      <Detail>
        {props.cause && <p>原因: {props.cause}</p>}
        {props.solution && <p>解決策: {props.solution}</p>}
      </Detail>
    )}
    <ButtonContainer>
      <Button variant='fill' onClick={props.onBackToTop}>
        トップに戻る
      </Button>
    </ButtonContainer>
  </Container>
);

export default ErrorPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const Title = styled.h1`
  color: ${color.text};
  text-align: center;
`;

const Detail = styled.div`
  color: ${color.text};
  text-align: center;
`;

const ButtonContainer = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;
